import React from 'react';
import styled from 'styled-components';
import { Button } from '@bijie/react-bnb';
import FlexBox from '../FlexBox';

const Wrap = styled(FlexBox)`
  width: 100%;
`;

const Content = styled.div`
  width: 450px;
  padding: 40px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.04);
  border-radius: 3px;
  margin: 0 auto;
  margin-top: 100px;
  margin-bottom: 300px;
  text-align: center;
  img {
    max-width: 104px;
    height: auto;
  }
  h3 {
    font-size: 24px;
    color: #212833;
    line-height: 32px;
    margin-top: 30px;
    margin-bottom: 0;
  }
  p {
    font-size: 14px;
    font-size: 14px;
    font-family: IBMPlexSans;
    color: #41485d;
    margin-top: 20px;
    margin-bottom: 0;
    line-height: 18px;
    word-break: break-word;
  }
  button {
    width: 100%;
    margin-top: 30px;
  }
`;

type Props = {
  imgType: boolean,
  title: string,
  msg: string,
  btnName: string,
  btnLink: string,
  id: string,
  content: Object,
};

const CallbackModule = ({
  imgType, title, msg, btnName, btnLink, id, content,
}: Props) => (
  <Wrap flex="1" justify="center">
    <FlexBox direction="column">
      <Content>
        <div>
          <img
            src={imgType && require(`./${imgType}.svg`)}
            width="104"
            height="104"
            alt={imgType}
          />
          <h3>{title}</h3>
          <p>{msg}</p>
          {btnName ? (
            <FlexBox justify="center">
              <Button type="primary" id={id} onClick={() => { window.location.href = btnLink; }}>
                {btnName}
              </Button>
            </FlexBox>
          ) : null}
          {content}
        </div>
      </Content>
    </FlexBox>
  </Wrap>
);

CallbackModule.defaultProps = {
  imgType: 'success',
  title: '',
  msg: '',
  btnName: '',
  btnLink: '',
  id: '',
  content: null,
};

export default CallbackModule;
